import axios from "axios";
import { ICamera } from "../model/camera.model";

export class CameraService {
  private static rootUrl = '/api/camera';
  private static client = axios;

  static async addCamera(camera: { 
    displayName: string; 
    url: string; 
    abstandsschwelle: number; 
    websocketOff?: boolean;
    rtspUser?: string;
    rtspPwd?: string;
    plainUrl?: string;
  }): Promise<void> {
    try {
      // Stellen Sie sicher, dass alle erforderlichen Felder vorhanden sind
      const cameraData = {
        ...camera,
        // Setze Default-Werte, falls nicht angegeben
        websocketOff: camera.websocketOff !== undefined ? camera.websocketOff : true
      };
      
      // Erweitere das Logging, um die gesendeten Daten zu prüfen
      console.log('CameraService - Sending data to API:', JSON.stringify(cameraData, null, 2));
      console.log('CameraService - API URL:', this.rootUrl);
      
      // Explizit die fehlenden Felder überprüfen und hervorheben
      if (!cameraData.rtspUser || !cameraData.rtspPwd || !cameraData.plainUrl) {
        console.warn('CameraService - WICHTIG: Fehlende Daten in der Anfrage:', {
          rtspUser: cameraData.rtspUser || 'FEHLT',
          rtspPwd: cameraData.rtspPwd || 'FEHLT',
          plainUrl: cameraData.plainUrl || 'FEHLT'
        });
      }
      
      const response = await this.client.post(this.rootUrl, cameraData);
      console.log('CameraService - Response from backend:', response.data);
      
      return response.data;
    } catch (error) {
      console.error('Fehler beim Hinzufügen der Kamera:', error);
      throw error;
    }
  }

  static async deleteCamera(cameraId: string): Promise<any> {
    try {
      const response = await this.client.delete(`${this.rootUrl}/${cameraId}`);
      return response.data;
    } catch (error) {
      console.error(`Fehler beim Löschen der Kamera ${cameraId}:`, error);
      throw error;
    }
  }

  static async getAllCameras(): Promise<ICamera[]> {
    try {
      const response = await this.client.get<ICamera[]>(this.rootUrl);
      return response.data;
    } catch (error) {
      console.error('Fehler beim Abrufen der Kameras:', error);
      throw error;
    }
  }

  static async updateCamera(cameraId: string, camera: Partial<ICamera>): Promise<ICamera> {
    try {
      // Zusätzliches Logging für Debugging-Zwecke
      console.log(`PATCH-Anfrage an: ${this.rootUrl}/${cameraId}`, camera);
      
      const response = await this.client.patch(`${this.rootUrl}/${cameraId}`, camera);
      console.log('Erfolgreiche Antwort:', response.data);
      return response.data;
    } catch (error) {
      console.error(`Fehler beim Aktualisieren der Kamera ${cameraId}:`, error);
      throw error;
    }
  }
}
